import React, { useState } from 'react'
import BannerSection from '../../components/bannerSection/BannerSection'
import AdvertisingBanner from '../../components/advertisingBanner/AdvertisingBanner'
import Img1 from '../../assets/images/mainSection/1.png';
import Img2 from '../../assets/images/mainSection/2.png';
import Img3 from '../../assets/images/mainSection/3.png';
import Img4 from '../../assets/images/mainSection/4.png';
import Img5 from '../../assets/images/mainSection/5.png';
import Img6 from '../../assets/images/mainSection/6.jpg';
import Img7 from '../../assets/images/mainSection/7.png';
import Img8 from '../../assets/images/mainSection/8.png';
import Img9 from '../../assets/images/mainSection/9.jpg';
import Footer from '../../components/footer/Footer'
import RegularImageSlider from '../../components/regularImage/RegularImage'
import RulesBanner from '../../components/RulesBanner/RulesBanner';


const Home = ({ isRtl, toggleLanguage, currentIndex, setCurrentIndex, pauseTransition }) => {



    const slides = [
        {
            title: {
                en: 'Establishments Data Management',
                ar: 'إدارة ملف المنشأة',
            },
            descriptions: {
                en: [
                    'HR PASS enables you to manage, store, and update all official data and documents of your establishment, Designed to meet the highest standards of quality, confidentiality, and security.',
                ],
                ar: [
                    'يتيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات و الملفات الرسمـية للمنشأة من منصة واحدة تتمـتع بأعـلى معـاييـر الجـودة والسرية والأمـان، و إمكـانـيـة تنبيـه صـاحـب المنشأة بتواريخ جميع الأوراق الرسمـية للمنشأة وسهـلة الوصول إليها من أي مكان و في أي وقت.',
                ],
            },
            imgSrc: Img1,
            imgClass: 'fullImg',
        },
        {
            title: {
                en: 'Employee Data Management',
                ar: 'إدارة بيانات الموظفين',
            },
            descriptions: {
                en: [
                    'HR PASS enables you to manage, save, and modify all employee data from a single pla orm that adheres to the highest standards of quality and security.',
                    'Access employee data from anywhere, at any ensuring ﬂexibility and control over HR opera ons.',
                ],
                ar: [
                    'تيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات الموظفين من منصة واحدة تتمتع بأعلى معايير الجودة و الأمـان.  يمكن اسـتخـدامهـا و الحصول عليهـا من أي مكـان، ويسهل البحث فيها للوصول إلى أي معلومة عن أي موظف في أي وقت.',
                ]
            },
            imgSrc: Img2,
            imgClass: 'halfImg',
        },
        {
            title: {
                en: 'Speed of Salary Payment',
                ar: 'سرعة تسديد الرواتب',
            },
            descriptions: {
                en: [
                    'With HR PASS, salary calcula ons are veriﬁed, automated, and organized in full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE).',
                    'Say goodbye to manual calcula ons and reduce human error with automa c, precise salary computa ons.',
                ],
                ar: [
                    'مـع نظــام اتش ار باس ، حـسابـات موثـقـة وتلقــائية و منظـمـة للرواتب بالتوافق مع قـوانين وزارة الموارد البشرية و التوطـين، وداعاً للحسابات اليدوية وفوضى الجداول والبيانات المبعثرة.',
                ]
            },
            imgSrc: Img3,
            imgClass: 'fullImg',

        },
        {
            title: {
                en: 'A endance and Leaves',
                ar: 'الحضور و الانصراف',
            },
            descriptions: {
                en: [
                    'Track employee a endance remotely with ease.',
                    'Say goodbye to manual employee a endance and departure recording and manual data transfer for payroll calcula on.',
                ],
                ar: [
                    'وداعاً لنقل بيانات الحضور والانصراف وسهولة تسجيلها وتتبع مواقع المـوظـفـين  و سهـولـة ربـط نظـام اتش ار بـاس مع أجـهـزة البصمة،  وربطها بالرواتب والإجازات والغيابات مباشرة.',
                ]
            },
            imgSrc: Img4,
            imgClass: 'autoImg',

        },
        {
            title: {
                en: 'Letters Requests',
                ar: 'طـلبــات الخـطابات',
            },
            descriptions: {
                en: [
                    'With HR PASS, both the facility owner and employees can easily request various types of le ers directly through the system.These le ers comply with the requirements of the Ministry of Human Resources and Emira sa on(MOHRE), ensuring that they are documented and comprehensive to protect all par es and prevent future disputes Employees and management can request diﬀerent types of le ers (e.g., salary cer ﬁcates, NOC, experience le ers) directly through the pla orm..The HR team can create and customize le er templates to suit various needs, streamlining the process for repe ve requests.',
                ],
                ar: [
                    'يمكن لصاحب المنشأة والموظفين طلب الخطابات بمختلف أنواعها مباشرة عبر نظام اتش ار باس، بالتوافق مع متطلبات وزارة الموارد البشرية والتوطين لتكون موثقة وشاملة لضمان جميع الحقوق بما يمنع حدوث خلافات مستقبلية ، ويستطيع فريق الموارد البشرية إنشاء قوالب خطابات قابلة للتخصيص.',
                ],
            },
            imgSrc: Img5,
            imgClass: 'fullImg',
        },
        {
            title: {
                en: 'Employee Leaves',
                ar: 'إجــازات الموظـفين',
            },
            descriptions: {
                en: [
                    'HR PASS allows for seamless management and tracking of employee leave balances, providing high accuracy and full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE) in the UAE.',
                ],
                ar: [
                    'سهولة حساب وتتبع إجـازات الموظفين والوصول إلى أرصدة الموظفين لجميع أنواع الاجازات بدقة عالية و بما يتوافق مع قـوانين وزارة الموارد البشرية و التـوطـين في دولـة الإمـارات العربية المتحدة.',
                ]
            },
            imgSrc: Img6,
            imgClass: 'fullImg',
        },
        {
            title: {
                en: 'Employee Warnings',
                ar: 'إنـذارات المـوظفـين',
            },
            descriptions: {
                en: [
                    'HR PASS enables you to create and manage internal organiza onal regula ons, document employee penal es, and maintain comprehensive records throughout an employee’s service',
                ],
                ar: [
                    'إنشاء لوائح تنظيمة داخلية  للمنشأة و توثيق جـميع أنواع الجـزاءات للموظـفين و الحـفـاظ على سجلاتهم و سهـولة الوصول إليها طوال خدمة الموظف.',
                ]
            },
            imgSrc: Img7,
            imgClass: 'fullImg',
        },
        {
            title: {
                en: 'End Of Service',
                ar: 'نهـاية الخــدمـة',
            },
            descriptions: {
                en: [
                    'HR PASS simpliﬁes the end-of-service process by ensuring accurate calcula ons and proper documenta on, in full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE) in the UAE.',
                ],
                ar: [
                    'يتيح لك نظام حساب نهاية الخدمة و براءة ذمـة الموظـفين مـن جمـيع الاستحـقـاقـات وتـوثيـقـهـا حـسب قـوانـين وزارة الموارد البشرية والتوطين في دولة الإمارات العربية المتحدة.',
                ]
            },
            imgSrc: Img8,
            imgClass: 'fullImg',
        },
        {
            title: {
                en: 'Employee Files',
                ar: 'ملفـات المـوظـفين',
            },
            descriptions: {
                en: [
                    'HR PASS streamlines the management of employee ﬁles, ensuring mely alerts and easy access to important documents.',
                    'Expira on Date Alerts: Automa cally no fy the facility owner of upcoming expira on dates for oﬃcial employee documents, such as visas, IDs, contracts, and cer ﬁca ons, ensuring mely renewals',
                ],
                ar: [
                    'تنبيه صاحب المنشأة بجميع تواريخ انتهاء الأوراق الرسمية للمـوظـفـين و الحـفـاظ عـلى ملفـات الموظـفـين و سهـولـة الوصول للأوراق الرسمية للموظـف من أي مكـان و في أي وقت.',
                ]
            },
            imgSrc: Img9,
            imgClass: 'fullImg',
        },
    ];


    const englishTexts = [
        "Integrated platform... multiple capabilities",
        "Farewell distractions... welcome peace of mind.",
        "Let us manage your staff to save you time and effort.",
        "Monitor workflow and manage employees from anywhere at anytime.",
    ];

    const arabicTexts = [
        "منصة متكاملة ... إمكانيات متعددة",
        "وداعا للتشتت ... أهلا براحة البال -",
        "دعنا نتولى إدارة موظفيك لتوفير وقتك وجهدك.",
        "راقب سير العمل وإدارة الموظفين من أي مكان وفي أي زمان ",
    ];

    const secondEnglishTexts = [
        "HR Pass: The Gateway to Your New Business Journey",
        "HR Pass is an innovative step forward, setting the foundation for a bright and successful professional future. ",
        "By utilizing the HR Pass platform, you can achieve a significant and transformative improvement in how you manage your work life.",
    ];

    const secondArabicTexts = [
        "اتش ار باس ،  إشارة البدء لرحلة عمل جديدة.",
        "اتش ار باس ، نقلة مبتكرة لمستقبل مهني مشرق",
        "من خلال منصة اتش ار باس ،  يمكنك أن تُحدث تحولًا إيجابيًا وجذريًا في حياتك العملية.",
    ];


    return (
        <div>
            <BannerSection isRtl={isRtl} />
            <AdvertisingBanner texts={isRtl ? arabicTexts : englishTexts} isRtl={isRtl} />
            <div>
                <RegularImageSlider
                    slides={slides.map((slide) => ({
                        title: slide.title[isRtl ? 'ar' : 'en'],
                        descriptions: slide.descriptions[isRtl ? 'ar' : 'en'],
                        imgSrc: slide.imgSrc,
                        imgClass: slide.imgClass,
                    }))}
                    intervalTime={5000}
                    isRtl={isRtl}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    pauseTransition={pauseTransition}
                />
            </div>
            <AdvertisingBanner texts={isRtl ? secondArabicTexts : secondEnglishTexts} isRtl={isRtl} />
            <RulesBanner isRtl={isRtl} />
            <Footer />
        </div>
    )
}

export default Home